import { queryProvider, serviceQueries } from 'elc-service-bus';
import { TranslationsRepository } from '../internal/repositories/TranslationsRepository';

export class ServiceBusController {
    private translationsRepository: TranslationsRepository;

    constructor(translationsRepository: TranslationsRepository) {
        this.translationsRepository = translationsRepository;
    }

    @queryProvider(serviceQueries.GET_TRANSLATIONS)
    public loadTranslations = async (payload: string[]) => {
        return this.translationsRepository.getTranslations(payload);
    };
}
